<template>
	<div class="sys-setting header-padding">
		<f-page-header />
		<el-card class="a-card" v-loading="loading" shadow="never">
			<!-- <div class="me-item text-muted line">
        <div>
          <div>默认质检方案</div>
          <div class="text-black mt">{{ settingData.default_quality_scheme_title }}</div>
        </div>
        <el-button type="text" @click="setTime(1)">设置</el-button>
      </div> -->

			<div class="me-item text-muted line">
				<div>
					<div>工时单位设置</div>
					<div class="text-black mt">{{ settingData.workorder_standard_unit == 's' ? '秒' : settingData.workorder_standard_unit == 'min' ? '分钟' : '小时' }}</div>
				</div>
				<el-button class="ft" type="text" @click="setTime(2)">设置</el-button>
			</div>

			<div class="me-item text-muted line">
				<div>
					<div>工单开工时间设置</div>
					<div class="text-black mt">
						工单允许提前 <span class="text-warning number text-bold">{{ settingData.workorder_start_ahead || '0' }}</span> {{ unit }} 开工，超时 <span class="text-warning number text-bold">{{ settingData.workorder_start_delay || '0' }}</span>
						{{ unit }} 判定未开工异常
					</div>
				</div>
				<el-button class="ft" type="text" @click="setTime(3)">设置</el-button>
			</div>

			<div class="me-item text-muted line">
				<div>
					<div>工单完工时间设置</div>
					<div class="text-black mt">
						工单超时 <span class="text-warning number text-bold">{{ settingData.workorder_end_delay || '0' }}</span> {{ unit }} 开工，判定未完工异常
					</div>
				</div>
				<el-button class="ft" type="text" @click="setTime(4)">设置</el-button>
			</div>

			<div class="me-item text-muted line">
				<div>
					<div>自建工单设置</div>
					<div class="text-black mt">
						<span class="">{{ 1 ? '允许' : '不允许' }}</span>小程序自建工单
					</div>
				</div>
				<el-switch class="ft" v-model="settingData.workorder_create_from_wxapp_enable" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="post({ workorder_create_from_wxapp_enable: settingData.workorder_create_from_wxapp_enable })">
				</el-switch>
			</div>

			<div class="me-item text-muted line">
				<div>
					<div>报工工时设置</div>
					<div class="text-black mt">
						<span class="">{{ 1 ? '允许' : '不允许' }}</span>报工工时与计划工时不一致
					</div>
				</div>
				<el-switch class="ft" v-model="settingData.workorder_hour_mismatch_enable" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="post({ workorder_hour_mismatch_enable: settingData.workorder_hour_mismatch_enable })">
				</el-switch>
			</div>

			<div class="me-item text-muted line">
				<div>
					<div>工位绑定操作设置</div>
					<div class="text-black mt">
						工位<span class="">{{ 1 ? '允许' : '不允许' }}</span>多个操作绑定
					</div>
				</div>
				<el-switch class="ft" v-model="settingData.workstation_multi_operator_enable" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="post({ workstation_multi_operator_enable: settingData.workstation_multi_operator_enable })"></el-switch>
			</div>

			<div class="me-item text-muted line">
				<div>
					<div>工位绑定质检设置</div>
					<div class="text-black mt">
						工位<span class="">{{ 1 ? '允许' : '不允许' }}</span>多个质检绑定
					</div>
				</div>
				<el-switch class="ft" v-model="settingData.workstation_multi_inspector_enable" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="post({ workstation_multi_inspector_enable: settingData.workstation_multi_inspector_enable })"></el-switch>
			</div>
		</el-card>

		<el-dialog title="系统设置" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :modal-append-to-body="false" :close-on-click-modal="false">
			<el-form :model="formData" :rules="Rules" label-position="left">
				<el-form-item v-if="type == 4" label="完工允许超时时间" :label-width="formLabelWidth" prop="endDelay">
					<div class="flex">
						<el-input v-model="formData.workorder_end_delay" class="bd" autocomplete="off"></el-input>
						<div class="ft pl pr">{{ unit }}</div>
					</div>
				</el-form-item>
				<el-form-item v-if="type == 3" label="开工允许提前时间" :label-width="formLabelWidth" prop="startAhead">
					<div class="flex">
						<el-input v-model="formData.workorder_start_ahead" class="bd" autocomplete="off"></el-input>
						<div class="ft pl pr">{{ unit }}</div>
					</div>
				</el-form-item>
				<el-form-item v-if="type == 3" label="开工允许超时时间" :label-width="formLabelWidth" prop="startDelay">
					<div class="flex">
						<el-input v-model="formData.workorder_start_delay" class="bd" autocomplete="off"></el-input>
						<div class="ft pl pr">{{ unit }}</div>
					</div>
				</el-form-item>
				<el-form-item v-if="type == 2" label="工时单位设置" :label-width="formLabelWidth" prop="standardUnit">
					<div style="width: 120px">
						<el-select v-model="formData.workorder_standard_unit" placeholder="请选择活动区域" style="width: 120px">
							<el-option label="秒(s)" value="s"></el-option>
							<el-option label="分钟(min)" value="min"></el-option>
							<el-option label="小时(h)" value="h"></el-option>
						</el-select>
					</div>
				</el-form-item>
				<el-form-item v-if="type == 1" label="质检方案" prop="schemeid">
					<qc-scheme-selector v-model="formData.default_quality_scheme" placeholder="请选择" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button v-if="type == 1" type="primary" @click="post({ default_quality_scheme: formData.default_quality_scheme })">确 定</el-button>
				<el-button v-if="type == 2" type="primary" @click="post({ workorder_standard_unit: formData.workorder_standard_unit })">确 定</el-button>
				<el-button v-if="type == 3" type="primary" @click="post({ workorder_start_delay: formData.workorder_start_delay, workorder_start_ahead: formData.workorder_start_ahead })">确 定</el-button>
				<el-button v-if="type == 4" type="primary" @click="post({ workorder_end_delay: formData.workorder_end_delay })">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getSettingApi, postSettingApi } from '@/api/sys/enterpriseApi'
export default {
	name: 'SysSetting',
	components: {
		QcSchemeSelector: () => import('@/views/qc/components/QcSchemeSelector')
	},
	data () {
		return {
			loading: false,
			postLoading: false,
			dialogVisible: false,
			type: null,
			settingData: {
				default_quality_scheme: 1, //       默认质检方案ID
				workorder_standard_unit: 'minute', //  工时单位设置
				workorder_start_ahead: 15, //  工单允许提前___min开工
				workorder_start_delay: 15, //   工单开工后允许滞后时间 min
				workorder_end_delay: 15, // 工单超时____min，判定未完工异常
				workorder_hour_mismatch_enable: 1, // 是否允许报工工时与计划工时不一致，1代表允许
				workorder_create_from_wxapp_enable: 0, //是否允许小程序自建工单， 1代表允许
				workstation_multi_operator_enable: 1, // 工位是否允许多个操作绑定，1代表允许
				workstation_multi_inspector_enable: 1, //   工位是否允许多个质检绑定，1代表允许
				default_quality_scheme_title: '默认质检方案'
			},
			formData: {},
			postData: {},
			formLabelWidth: '140px',
			Rules: {},
			unit: 'min'
		}
	},
	computed: {},
	created () {
		this.fetchData()
	},
	methods: {
		fetchData () {
			this.loading = true
			getSettingApi().then(res => {
				this.loading = false
				this.settingData = res.data
				// this.unit = res.data.workorder_standard_unit
				this.postData = Object.assign({}, res.data)
			})
		},
		post (data) {
			this.loading = true
			postSettingApi(data).then(res => {
				this.loading = false
				if (res.errno) {
					this.$message.error(res.message)
				} else {
					this.dialogVisible = false
					this.postData = {}
					this.fetchData()
					this.$message.success(res.message)
				}
			})
		},
		cancel () {
			this.settingData = Object.assign({}, this.postData)
			this.dialogVisible = false
		},

		setTime (type) {
			this.type = type
			this.formData = Object.assign({}, this.settingData)
			this.dialogVisible = true
		},
		handleClose () {
			this.settingData = Object.assign({}, this.postData)
			this.dialogVisible = false
			this.type = null
		}
	}
}
</script>

<style lang="scss" scoped>
.sys-setting {
	.a-card {
		width: 1180px;
		padding: 40px 100px;
		min-height: 800px;
		margin: auto;
	}

	.me-item {
		position: relative;
		padding: 15px 0px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.line {
		width: 100%;
		border-bottom: 1px solid #ebeef5;
	}
}
</style>